function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@okee-uikit/react-hooks';
import { ColumnType } from '../type';
export var ColumnBase = function (_Emitter) {
  _inherits(ColumnBase, _Emitter);

  var _super = _createSuper(ColumnBase);

  function ColumnBase(manager, options, parent) {
    var _this;

    _classCallCheck(this, ColumnBase);

    _this = _super.call(this);
    _this.show = false;
    _this.fixed = false;
    _this.disposed = false;
    var key = options.key,
        type = options.type,
        renderHead = options.renderHead;
    _this.manager = manager;
    _this.parent = parent || null;
    _this.type = type;
    _this.key = key;
    _this.renderHead = renderHead;
    return _this;
  }

  _createClass(ColumnBase, [{
    key: "repaint",
    value: function repaint() {
      this.emit('repaint');
    }
  }, {
    key: "updateColumnOptions",
    value: function updateColumnOptions(options) {
      var type = options.type,
          _options$fixed = options.fixed,
          fixed = _options$fixed === void 0 ? false : _options$fixed,
          _options$show = options.show,
          show = _options$show === void 0 ? true : _options$show,
          key = options.key,
          renderHead = options.renderHead;

      if (type !== this.type) {
        throw new Error("update column with different type, expect = ".concat(this.type, "actual = ").concat(type));
      }

      if (key !== this.key) {
        throw new Error("update column with different key, expect = ".concat(this.key, "actual = ").concat(key));
      }

      this.renderHead = renderHead;
      this.fixed = fixed;
      this.show = show;
    }
  }, {
    key: "isTop",
    value: function isTop() {
      return this.parent == null;
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this.parent;
    }
  }, {
    key: "getFixedType",
    value: function getFixedType() {
      var parent = this.getParent();
      return parent ? parent.getFixedType() : this.fixed;
    }
  }, {
    key: "getKey",
    value: function getKey() {
      return this.key;
    }
  }, {
    key: "isShow",
    value: function isShow() {
      return this.show;
    }
  }, {
    key: "isParentShow",
    value: function isParentShow() {
      var parent = this.getParent();
      return parent ? parent.isParentShow() && this.isShow() : this.isShow();
    }
  }, {
    key: "isActualShow",
    value: function isActualShow() {
      if (!this.isShow()) {
        return false;
      }

      if (!this.isParentShow()) {
        return false;
      }

      if (this.isGroup()) {
        return this.getColumns().some(function (item) {
          return item.isActualShow();
        });
      }

      return true;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      var parent = this.getParent();
      return parent ? parent.getLevel() + 1 : 1;
    }
  }, {
    key: "isGroup",
    value: function isGroup() {
      return this.type === ColumnType.GROUP;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }

      this.removeAllListeners();
      this.disposed = true;
    }
  }, {
    key: "isDisposed",
    value: function isDisposed() {
      return this.disposed;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.type;
    }
  }]);

  return ColumnBase;
}(Emitter);